"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var tabs_1 = require("../tabs");
var TabsPanel = /** @class */ (function (_super) {
    tslib_1.__extends(TabsPanel, _super);
    function TabsPanel(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onChange = function (name) {
            var onChange = _this.props.onChange;
            onChange(parseInt(name, 10));
        };
        _this.setContentRef = function (el) {
            _this.$content = el;
        };
        _this.onTransitionEnd = function (e) {
            if (!_this.$content.isSameNode(e.target)) {
                return;
            }
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.$content.style.height = "";
            window.clearTimeout(_this.animationEndTimeout);
            _this.animationEndTimeout = setTimeout(onAnimationEnd);
        };
        _this.onContextFieldValidationChange = function (contextFieldId, isValid, tabContentId) {
            var $rawField = document.querySelector("[data-form-field-id=\"" + contextFieldId + "\"]");
            if ($rawField && !_this.$root.contains($rawField)) {
                return;
            }
            var tabContent = _this.getOrCreateTabContent(tabContentId);
            var tabContentFiedIndex = tabContent.invalidFields.indexOf(contextFieldId);
            if (isValid) {
                if (tabContentFiedIndex > -1) {
                    tabContent.invalidFields.splice(tabContentFiedIndex, 1);
                }
            }
            else {
                if (tabContentFiedIndex < 0) {
                    tabContent.invalidFields.push(contextFieldId);
                }
            }
            _this.scheduleForceUpdate();
        };
        _this.onUnregisterContextField = function (contextFieldId, tabContentId) {
            var tabContent = _this.getOrCreateTabContent(tabContentId);
            var tabContentFiedIndex = tabContent.invalidFields.indexOf(contextFieldId);
            if (tabContentFiedIndex > -1) {
                tabContent.invalidFields.splice(tabContentFiedIndex, 1);
                _this.scheduleForceUpdate();
            }
        };
        _this.registerTabContent = function (tabContentId) {
            if (_this.tabs[tabContentId]) {
                return;
            }
            _this.tabs[tabContentId] = {
                invalidFields: []
            };
        };
        _this.setRef = function (el) {
            _this.$root = el;
        };
        _this.$root = null;
        _this.$content = null;
        _this.animationEndTimeout = null;
        _this.tabs = {};
        return _this;
    }
    TabsPanel.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.selectedIndex !== this.props.selectedIndex) {
            this.setContentHeight(nextProps);
        }
    };
    TabsPanel.prototype.scheduleForceUpdate = function () {
        var _this = this;
        clearTimeout(this.asyncUpdaterId);
        this.asyncUpdaterId = setTimeout(function () { return _this.forceUpdate(); });
    };
    TabsPanel.prototype.setContentHeight = function (props) {
        var selectedIndex = props.selectedIndex;
        var $willBeActive = this.$content.querySelectorAll("[data-tab-content]")[selectedIndex];
        var $currentActive = this.$content.querySelector("[data-tab-content-active='true']");
        if ($willBeActive) {
            this.$content.style.height = $currentActive.offsetHeight + "px";
            this.$content.style.height = $willBeActive.offsetHeight + "px";
        }
    };
    TabsPanel.prototype.getOrCreateTabContent = function (tabContentId) {
        if (!this.tabs[tabContentId]) {
            this.registerTabContent(tabContentId);
        }
        return this.tabs[tabContentId];
    };
    TabsPanel.prototype.renderPanelContent = function (child, idx, isSelected) {
        var _a;
        var _b = this.props, theme = _b.theme, selectedIndex = _b.selectedIndex;
        var classes = classnames_1.default(theme["tab-content"], (_a = {},
            _a[theme.active] = isSelected,
            _a[theme.left] = !isSelected && idx < selectedIndex,
            _a[theme.right] = !isSelected && idx > selectedIndex,
            _a));
        return (React.createElement(tabs_1.TabContent, { className: classes, key: idx, isSelected: isSelected, id: idx, onContextFieldValidationChange: this.onContextFieldValidationChange, onUnregisterContextField: this.onUnregisterContextField }, child.props.children));
    };
    TabsPanel.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, children = _b.children, theme = _b.theme, className = _b.className, selectedIndex = _b.selectedIndex, animate = _b.animate, tabsProps = _b.tabsProps, others = tslib_1.__rest(_b, ["children", "theme", "className", "selectedIndex", "animate", "tabsProps"]);
        var classes = classnames_1.default(theme.panel, className, (_a = {},
            _a[theme.animate] = animate,
            _a));
        var contentProps = {
            className: theme.content,
            ref: this.setContentRef
        };
        if (animate) {
            contentProps.onTransitionEnd = this.onTransitionEnd;
        }
        var tabHeaderIndex = -1;
        var tabContentIndex = -1;
        var content = React.Children.map(children, function (child) {
            if (!child) {
                return null;
            }
            tabContentIndex++;
            return _this.renderPanelContent(child, tabContentIndex, tabContentIndex === selectedIndex);
        });
        var tabs = React.Children.map(children, function (child) {
            if (!child) {
                return null;
            }
            tabHeaderIndex++;
            var tabContent = _this.tabs[tabHeaderIndex];
            return React.cloneElement(child, tslib_1.__assign({}, child.props, { name: tabHeaderIndex, active: tabHeaderIndex === selectedIndex, children: null, isInvalid: tabContent && tabContent.invalidFields.length }));
        });
        return (React.createElement("div", { className: classes, ref: this.setRef },
            React.createElement(tabs_1.Tabs, tslib_1.__assign({}, others, tabsProps, { active: selectedIndex.toString(), onChange: this.onChange }), tabs),
            React.createElement("div", tslib_1.__assign({}, contentProps), content)));
    };
    TabsPanel.defaultProps = {
        selectedIndex: 0,
        onChange: utils_1.noop,
        onAnimationEnd: utils_1.noop,
        tabsProps: {}
    };
    return TabsPanel;
}(React.Component));
exports.default = TabsPanel;
